import React from "react";

import { Link, useLocation } from "react-router-dom";

export const Layout = () => {
  const currenturl = useLocation().pathname;
  return (
    <>
      <div
        _ngcontent-hdd-c162=""
        className="col-12 left-tab-box d-none d-sm-none d-md-none d-lg-block"
      >
        <div
          _ngcontent-hdd-c162=""
          className="d-flex flex-row justify-content-center align-items-center"
        >
          <div _ngcontent-hdd-c162="" className="dropdown">
            <button _ngcontent-hdd-c162="" className="dropbtn">
              myBets{" "}
              <img
                _ngcontent-hdd-c162=""
                className="arrow"
                alt=""
                src="/assets/images/arrow.png"
              />
            </button>
            <div _ngcontent-hdd-c162="" className="dropdown-content nav-link">
              <Link
                _ngcontent-hdd-c162=""
                routerlink="/reports/casinobets"
                routerlinkactive="active"
                className="nav-link"
              >
                Casino Bets
              </Link>
              <Link
                _ngcontent-hdd-c162=""
                routerlink="/reports/fancybets"
                routerlinkactive="active"
                className="nav-link"
              >
                Fancy Bets
              </Link>
              <Link
                _ngcontent-hdd-c162=""
                routerlink="/reports/sportsbets"
                routerlinkactive="active"
                className="nav-link"
              >
                Sports Bets
              </Link>
            </div>
          </div>
          <div _ngcontent-hdd-c162="" className="dropdown">
            <button _ngcontent-hdd-c162="" className="dropbtn">
              reportsandStatement{" "}
              <img
                _ngcontent-hdd-c162=""
                className="arrow"
                alt=""
                src="/assets/images/arrow.png"
              />
            </button>
            <div _ngcontent-hdd-c162="" className="dropdown-content nav-link">
              <Link
                _ngcontent-hdd-c162=""
                to="/accountstatement"
                routerlinkactive="active"
                className={`nav-link ${
                  currenturl === "/accountstatement" ? "active" : ""
                }`}
              >
                Account Statement
              </Link>
              <Link
                _ngcontent-hdd-c162=""
                to="/plstatement"
                routerlinkactive="active"
                className={`nav-link ${
                  currenturl === "/plstatement" ? "active" : ""
                }`}
              >
                Profit &amp; Loss
              </Link>
              <Link
                _ngcontent-hdd-c162=""
                to="/result"
                routerlinkactive="active"
                className={`nav-link ${
                  currenturl === "/result" ? "active" : ""
                }`}
              >
                Results
              </Link>
            </div>
          </div>
          <div _ngcontent-hdd-c162="" className="dropdown ng-star-inserted">
            <button _ngcontent-hdd-c162="" className="dropbtn">
              {" "}
              Payments{" "}
              <img
                _ngcontent-hdd-c162=""
                className="arrow"
                alt="dude"
                src="/assets/images/arrow.png"
              />
            </button>
            <div _ngcontent-hdd-c162="" className="dropdown-content nav-link">
              <Link
                to="/deposit"
                _ngcontent-hdd-c162=""
                routerlinkactive="active"
                className="nav-link"
              >
                <img
                  _ngcontent-hdd-c162=""
                  alt="dude"
                  className="imgdeposit"
                  src="/assets/images/cash1.svg"
                />
                Deposit
              </Link>
              <Link
                to="/withdraw"
                _ngcontent-hdd-c162=""
                className={`nav-link ${
                  currenturl === "/withdraw" ? "active" : ""
                }`}
              >
                Withdraw
              </Link>
              <Link
                to="/withdrawhistory"
                _ngcontent-hdd-c162=""
                routerlinkactive="active"
                className={`nav-link ${
                  currenturl === "/withdrawhistory" ||
                  currenturl === "/depositehistory"
                    ? "active"
                    : ""
                }`}
              >
                Deposit/Withdraw Requests History
              </Link>
            </div>
          </div>
          <div _ngcontent-hdd-c162="" className="dropdown">
            <button _ngcontent-hdd-c162="" className="dropbtn">
              settings{" "}
              <img
                _ngcontent-hdd-c162=""
                className="arrow"
                alt="dude"
                src="/assets/images/arrow.png"
              />
            </button>
            <div _ngcontent-hdd-c162="" className="dropdown-content nav-link">
              <Link
                _ngcontent-hdd-c162=""
                to="/changepassword"
                routerlinkactive="active"
                className={`nav-link ${
                  currenturl === "/changepassword" ? "active" : ""
                }`}
              >
                Change Password
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
